// Global constants

// Currency symbol, defaulting to "R" if not set in environment
export const CURRENCY_SYMBOL = process.env.CURRENCY_SYMBOL || "R";

// Phone number validation constants - Current default is South Africa
export const COUNTRY_CODE = process.env.COUNTRY_CODE || '+27';
export const ISO2 = process.env.ISO2 || 'za';
export const VALID_NUMBER_LENGTH = parseInt(process.env.VALID_NUMBER_LENGTH || '12', 10);
export const VALID_NUMBER_REGEX = new RegExp(process.env.VALID_NUMBER_REGEX || '^27[1-9]\\d{8}$');